"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var queryString = require("query-string");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var managementActions = require("@caddigital/sok-reducers/lib/actions/management");
var translate_1 = require("utils/translate");
var search_1 = require("utils/search");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var ProjectUsers_1 = require("./ProjectUsers");
var CompanyUserGroups_1 = require("./CompanyUserGroups");
var ReportsTab_1 = require("./components/ReportsTab");
require("./style.scss");
var mapStateToProps = function (state) {
    return {
        current: state.management.current
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (id) {
        return dispatch(managementActions.CurrentActions.fetchRequest(id));
    },
    clear: function () { return (dispatch(managementActions.CurrentActions.clear()),
        dispatch(managementActions.ProjectsActions.clear()),
        dispatch(managementActions.ProjectUsers.clear())); }
}); };
function parseSearchString(location) {
    var params = queryString.parse(location.search);
    var keys = Object.keys(params).sort(function (a, b) { return a.localeCompare(b); });
    // Decode params
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        params[key] = decodeURIComponent(params[key]);
    }
    return params;
}
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('queryParams', 'setQueryParams', null), (0, recompose_1.withState)('step', 'setStep', 0), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetch(parseInt(this.props.match.params.id, 10));
        var params = parseSearchString(this.props.location);
        var updatedParams = __assign(__assign({}, ProjectUsers_1.defaultParams), params);
        var url = this.props.location.pathname + (0, search_1.getQueryParams)(updatedParams);
        this.props.history.replace(url);
        this.props.setQueryParams(updatedParams);
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.props.fetch(parseInt(this.props.match.params.id, 10));
        }
        else if (this.props.current.status === 'STANDBY' &&
            this.props.current.status !== prevProps.current.status) {
            this.props.fetch(parseInt(this.props.match.params.id, 10));
        }
        if (this.props.location.search !== prevProps.location.search) {
            var params = parseSearchString(this.props.location);
            var updatedParams = __assign(__assign({}, ProjectUsers_1.defaultParams), params);
            this.props.setQueryParams(updatedParams);
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    if (props.queryParams === null) {
        return React.createElement("div", null);
    }
    return (React.createElement("div", { className: 'content-wrapper-content' },
        React.createElement("div", { className: 'customer-admin-management-view' },
            React.createElement("main", { className: 'content' },
                React.createElement(sok_ui_1.BreadCrumb, null,
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/") }, "SokoPro"),
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/management") }, (0, translation_1.getLocalization)('breadcrumb/management')),
                    props.current.customer ? (React.createElement("span", null, props.current.customer.name)) : undefined),
                props.current.status === 'FETCHING' && (React.createElement("div", { className: 'center-content' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.current.status === 'FAILED' && (React.createElement("div", { className: 'center-content' },
                    React.createElement(GenericErrorMessage_1.default, null,
                        React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                                return props.fetch(parseInt(props.match.params.id, 10));
                            } })))),
                props.current.status === 'FETCHED' && (React.createElement(sok_ui_1.Tabs, { activeIndex: props.step, onClick: props.setStep },
                    React.createElement("div", null, (0, translation_1.getLocalization)('management/projectUsers')),
                    React.createElement("div", null, (0, translation_1.getLocalization)('management/companyUserGroups')),
                    React.createElement("div", null, (0, translation_1.getLocalization)('management/reports')),
                    props.current.customer !== null ? (React.createElement(ProjectUsers_1.ProjectUsers, { updateUrl: props.history.push, queryParams: props.queryParams, pathname: props.location.pathname, currentCustomer: props.current.customer })) : (React.createElement("div", null)),
                    props.current.customer !== null ? (React.createElement(CompanyUserGroups_1.CompanyUserGroups, { updateUrl: props.history.push, queryParams: props.queryParams, pathname: props.location.pathname, currentCustomer: props.current.customer })) : (React.createElement("div", null)),
                    props.current.customer !== null ? (React.createElement(ReportsTab_1.ReportsTab, { currentCustomer: props.current.customer })) : (React.createElement("div", null))))))));
});
